//The ΑΦΜ lookup (server soap service, AADE RgWsPublic2) hands every field over as xml2js parsed it, and a field
//AADE leaves empty arrives as an OBJECT ({ 'xsi:nil': ['true'] }), never as ''. `.toString()` on that object is
//"[object Object]" - which a sole proprietor's missing legal_status_descr put into the form and onto the order,
//and a nil firm_act_tab made `.item.find` throw. Every read of an AADE value goes through aadeText, and a field
//with more than one source takes firstText of them. Port of nexio/dashboard shared/services/aadeText.ts.

//A string trimmed, a finite number as text, anything else ''. "[object Object]" is what an earlier save of a nil
//field left behind, so a stored copy of it counts as empty too.
export const aadeText = (value) => {
  const text = typeof value === 'string' ? value.trim()
    : typeof value === 'number' && Number.isFinite(value) ? `${value}` : '';
  return text === '[object Object]' ? '' : text;
};

//The first source that holds actual text (AADE first, then the stored record, then any fallback), else ''.
export const firstText = (...values) => values.map(aadeText).find(Boolean) || '';

//xml2js wraps every leaf of firm_act_tab in an array (firm_act_kind: ['1']); take either form.
const leaf = (value) => Array.isArray(value) ? value[0] : value;

//The main activity (firm_act_kind 1) of an AADE answer. The tab is a nil object or '' when the taxpayer has no
//activity (null from the HMRC lookup), and its item list is not guaranteed to be an array.
export const aadeMainActivity = (aade) => {
  const items = aade?.firm_act_tab?.item;
  const list = Array.isArray(items) ? items : (items && typeof items === 'object') ? [items] : [];
  const main = list.find(d => aadeText(leaf(d?.firm_act_kind)) === '1');
  return aadeText(leaf(main?.firm_act_descr));
};
